/* 
acquired by running:
query {
  headerV2: contentfulHeaderV2(
    brand: { elemMatch: { name: { eq: "TopCV.co.uk" } } }
  ) {
    ...HeaderV2
  }
}
*/

export const headerV2 = {
  headerV2: {
    contentful_id: '5Lv0mGzwuVV4w8drmeNvvv',
    name: 'TopCV.Co.UK Header',
    navigationLeftSide: null,
    navigationRightSide: [
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: 'oFRDMlem4imoGnlveHPMx',
        title: 'TopCV CV Services',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: 'pXmasnOtI4YKmElloZ710',
            text: 'CV Services',
            url: '/cv-writing?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'cv_services_click',
              trackingData: null,
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '5tCCzIH5SWLyiBqHpRZgs5',
        title: 'About',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '1Me20034i3bSsikrxuKKui',
            text: 'Our Company',
            url: '/about?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'our_company_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '7bpu5SfMPI8yOA6hEA25Ch',
            text: 'Frequently Asked Questions',
            url: '/faq?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'faqs_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '5BSQGqSde0I8Oh3XTtkBu6',
            text: 'Contact Us',
            url: '/contact?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'contact_us_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: 'Dropdown',
        link: null,
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '6qJ0FYpgtwx1rccjOJb7JC',
        title: 'Testimonials',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: 'UFhP8wQnS8GtabbfGPhfV',
            text: 'Customer Reviews',
            url: '/topcv-reviews?dt=discountToken',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'customer_reviews_click',
              trackingData: null,
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '6deKweYTIoKnBEgHrnOOPA',
            text: 'Success Stories',
            url: '/success-stories?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'success_stories_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: 'Dropdown',
        link: {
          contentful_id: '6LvhkrVBqsrBwZjO3n7xy7',
          __typename: 'ContentfulInternalLink',
          text: 'Testimonials',
          slug: 'success-stories?dt={{discountToken}}',
          icon: null,
          codeClasses: null,
          mixpanelTracking: {
            eventName: 'testimonials_click',
            trackingData: null,
            trackOn: null,
          },
        },
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '7BQ57lK79246x62nwxekhQ',
        title: 'Career Advice',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: 'Y2h2bAYQRkGU3j6otS9Oq',
            text: 'Career Advice',
            url: '/career-advice?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'career_advice_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: 'yFH843M759QrJTAXrQcgC',
        title: 'Account',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '3SS8YgrLHx06FnL0OQFXFl',
            text: 'Account',
            url: 'https://topcv.portal.careers',
            icon: {
              contentful_id: '5jk4SeTIq2N2sCTx6S8git',
              __typename: 'ContentfulAsset',
              description: '',
              gatsbyImageData: null,
              file: {
                url: '//images.ctfassets.net/7thvzrs93dvf/5jk4SeTIq2N2sCTx6S8git/bd3d32ef56283be0250fa43832fad0d3/account-icon-thin.svg',
                fileName: 'account-icon-thin.svg',
                contentType: 'image/svg+xml',
                details: {
                  image: {
                    width: 52,
                    height: 52,
                  },
                },
              },
            },
            openTheLinkIn: null,
            stagingUrl: 'https://staging.portal.careers',
            devUrl: 'https://dev.portal.careers',
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'login_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"navigation_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
      {
        id: '284b3608-f7e9-5599-80d0-a78a1c25edee',
        contentful_id: '5QOfGD73hQdCca6626ilbW',
        buttonText: 'SELECT YOUR COUNTRY',
        color: 'secondary',
        variant: 'text',
        role: 'Language Switcher',
        __typename: 'ContentfulButton',
        codeClasses: null,
        mixpanelTracking: {
          eventName: 'select_region_click',
          trackingData: null,
          trackOn: null,
        },
        action: {
          __typename: 'ContentfulModal',
          contentful_id: '4uuvbrn666f7yWWDZVxg40',
          name: 'Language Switcher Modal',
          variant: 'Language Switcher',
          steps: [
            {
              __typename: 'ContentfulModalStep',
              name: 'Language Switch Step',
              contentful_id: 'oD2b0s9qpymXiqk0DCaP2',
              content: {
                raw: '{"nodeType":"document","data":{},"content":[{"nodeType":"heading-1","data":{},"content":[{"nodeType":"text","value":"Select your country","marks":[],"data":{}}]},{"nodeType":"paragraph","data":{},"content":[{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"3xA0sKS8akM0dmyrpAOTzA","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"3V4D5jVe4WvHLYIONPL2DY","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"1HPwS7KB5wxzxN5z8MTDUI","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"4VsLdVezkkbr9S8hvffvCi","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":"","marks":[],"data":{}}]},{"nodeType":"paragraph","data":{},"content":[{"nodeType":"text","value":"","marks":[],"data":{}}]}]}',
                references: [
                  {
                    id: '69711b1a-a192-59a4-91da-6e80566810f5',
                    contentful_id: '3xA0sKS8akM0dmyrpAOTzA',
                    buttonText: 'x-default',
                    color: 'white',
                    variant: 'text',
                    role: 'Language Switcher',
                    __typename: 'ContentfulButton',
                    codeClasses: ['flagUS'],
                    mixpanelTracking: null,
                    action: {
                      contentful_id: 'aSZKGz04HRyKF984xsKt6',
                      text: 'https://topresume.com/',
                      url: 'https://topresume.com/?dt=discountToken',
                      __typename: 'ContentfulExternalLink',
                      codeClasses: null,
                      mixpanelTracking: null,
                    },
                  },
                  {
                    id: '9efe0c8c-7fbe-5ee9-a84b-90672d6cf1b2',
                    contentful_id: '3V4D5jVe4WvHLYIONPL2DY',
                    buttonText: 'en-gb',
                    color: 'white',
                    variant: 'text',
                    role: 'Language Switcher',
                    __typename: 'ContentfulButton',
                    codeClasses: ['flagUK'],
                    mixpanelTracking: null,
                    action: {
                      contentful_id: '1zg2HZrFcoIrnfFr7iEJ4V',
                      text: 'Top CV UK',
                      url: 'https://topcv.co.uk',
                      __typename: 'ContentfulExternalLink',
                      codeClasses: null,
                      mixpanelTracking: null,
                    },
                  },
                  {
                    id: '72e54fa1-ed4b-5bb6-8707-f23fea4db2d5',
                    contentful_id: '1HPwS7KB5wxzxN5z8MTDUI',
                    buttonText: 'de-de',
                    color: 'white',
                    variant: 'text',
                    role: 'Language Switcher',
                    __typename: 'ContentfulButton',
                    codeClasses: ['flagDE'],
                    mixpanelTracking: null,
                    action: {
                      contentful_id: '5Cy8wewMkT7D4Tgh0pBf8T',
                      text: 'https://topcv.de/',
                      url: 'https://topcv.de',
                      __typename: 'ContentfulExternalLink',
                      codeClasses: null,
                      mixpanelTracking: null,
                    },
                  },
                  {
                    id: 'e6b4a091-f369-5c15-b774-4b150a400db0',
                    contentful_id: '4VsLdVezkkbr9S8hvffvCi',
                    buttonText: 'fr-fr',
                    color: 'white',
                    variant: 'text',
                    role: 'Language Switcher',
                    __typename: 'ContentfulButton',
                    codeClasses: ['flagFR'],
                    mixpanelTracking: null,
                    action: {
                      contentful_id: '7Ev8G4QYrKDjZZOQh2mkyH',
                      text: 'https://topcv.fr/',
                      url: 'https://topcv.fr/',
                      __typename: 'ContentfulExternalLink',
                      codeClasses: null,
                      mixpanelTracking: null,
                    },
                  },
                ],
              },
            },
          ],
          completionRedirect: null,
          showCloseButton: true,
          color: 'White',
        },
      },
      {
        id: '1740d29d-dfb3-5d5b-8c23-481382244cd0',
        contentful_id: '2cbxLxt8cng6x2wCZv4XNs',
        buttonText: 'Buy Now',
        color: null,
        variant: null,
        role: null,
        __typename: 'ContentfulButton',
        codeClasses: ['mp_bn'],
        mixpanelTracking: {
          eventName: 'buy_now_click',
          trackingData: null,
          trackOn: null,
        },
        action: {
          contentful_id: '1r9Ph0MMzCAechDt6y1VXB',
          text: 'Resume Services',
          url: '/{{lowercased brand.flagshipProduct}}-writing?dt={{discountToken}}',
          __typename: 'ContentfulExternalLink',
          codeClasses: null,
          mixpanelTracking: null,
        },
      },
    ],
    hideBuyNowButton: null,
  },
}
